import { useQuery } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface PickerObject {
  uuid: string;
  label: string;
  data?: Record<string, unknown>;
}

interface UiPickerObjectsData {
  message: string;
  data: {
    items?: PickerObject[];
  };
}

export function useUiPickerObjects(type: string) {
  const { keycloak } = useKeycloak();

  return useQuery(['ui-picker-objects', type], {
    enabled: !!type,
    queryFn: async (): Promise<UiPickerObjectsData> => {
      const body = {
        type,
      };

      const response = await fetch(
        `${
          import.meta.env.VITE_API_URL
        }/bundles/query_bundle/functions/picker_objects`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(body),
        }
      );

      return response.json();
    },
  });
}
